import React from "react";

class NodoOrganigrama extends React.Component {
  constructor(props) {
    super(props);
    this.handleClick = this.handleClick.bind(this);
  }

  handleClick() {
    const { nodeDatum, onNodeClick } = this.props;
    onNodeClick(nodeDatum);
  }

  render() {
    const { nodeDatum } = this.props;
    const width = 260;
    const height = 160;

    return (
      <g>
        <foreignObject width={width} height={height} x="-130" y="-80">
          <div className="nodo-container">
            <button 
              className="card-estructura accent-brand open-dialog"
              onClick={this.handleClick}
              onMouseEnter={this.handleMouseEnter}
              onMouseLeave={this.handleMouseLeave}
            >
              <div className="card-contentInner">
                <div className="icon">
                  <span className="material-symbols-outlined">
                    portrait
                  </span>
                </div>
                <span className="card-name">
                  {nodeDatum.name}
                </span>
              </div>

              <div className="badges">
                <div className="badge-build">
                  <span className="material-symbols-outlined">
                    business
                  </span>
                  <span className="number number-bold">
                    {nodeDatum.cantidadPadres || 0}
                  </span>
                </div>
                <div className="badge-users">
                  <span className="material-symbols-outlined">
                    person
                  </span>
                  <span className="number">
                    {nodeDatum.cantidadMiembros}
                  </span>
                </div>
              </div>
            </button>
          </div>
        </foreignObject>
      </g>
    );
  }
}

export default NodoOrganigrama;
